<div class="document-viewer" [ngClass]="[isExternalApp ? 'external' : '']"
    data-automation-id="document-viewer-container">
    <res-top-nav-bar *ngIf="!isExternalApp"></res-top-nav-bar>
    <div class="top-toolbar">
        <button type="button" data-automation-id="document-viewer-exit-button" *ngIf="!isExternalApp"
            class="secondary-button" (click)="onCloseDocumentViewer()">
            <i class="fa fa-arrow-left color-grey-10"></i>Exit
        </button>
        <res-custom-select [items]="documentListBreadcrumbs" [selectedItem]="selectedDocumentListBreadcrumb"
            customClass="document-dropdown" [onSelectionChanged]="selectedDocumentListBreadcrumbChanged"
            automationId="document-viewer-breadcrumbs" [disabled]="documentListBreadcrumbs.length < 2">
        </res-custom-select>
        <ul class="nav nav-tabs">
            <li [ngClass]="{'active': displayFormat === DocumentFormat.HTML5_HIGHLIGHTED }"
                data-automation-id="document-viewer-html-tab"
                (click)="setDisplayFormat(DocumentFormat.HTML5_HIGHLIGHTED)">
                <a>HTML</a>
            </li>
            <li [ngClass]="{'active': displayFormat === DocumentFormat.TEXT }"
                data-automation-id="document-viewer-text-tab" (click)="setDisplayFormat(DocumentFormat.TEXT)">
                <a>Text</a>
            </li>
            <li [ngClass]="{'active': displayFormat === DocumentFormat.IMAGE_PDF, 'disabled' : (selectedDocument && !selectedDocument.stored_image)}"
                data-automation-id="document-viewer-image-tab" (click)="setDisplayFormat(DocumentFormat.IMAGE_PDF)"
                [title]="(selectedDocument && !selectedDocument.stored_image) ? 'Image Not Available' : ''">
                <a>Image</a>
            </li>
        </ul>
        <div class="document-filter"
            [ngClass]="[(externalParsingLibrary === 'OIT' && this.displayFormat !== DocumentFormat.TEXT ? documentTools.findInDocument.results && documentTools.findInDocument.results.length === 0 : documentTools.findInDocument?.results === 0) ? 'no-results' : '',
             documentTools.findInDocument.results && (externalParsingLibrary === 'OIT' && this.displayFormat !== DocumentFormat.TEXT ? documentTools.findInDocument.results.length > 0 : documentTools.findInDocument.results > 0) ? 'results' : '']">
            <input type="text" placeholder="Find in document ..." [(ngModel)]="documentTools.findInDocument.value"
                [disabled]="!documentTools.findInDocument.enabled()"
                (ngModelChange)="documentTools.findInDocument.search()"
                (keyup.enter)="documentTools.findInDocument.searchAfterBounce()"
                data-automation-id="document-viewer-document-filter-input"
                [ngStyle]="{'padding-right' : (documentTools.findInDocument.value &&
                (externalParsingLibrary === 'OIT' && this.displayFormat !== DocumentFormat.TEXT ? documentTools.findInDocument.results && documentTools.findInDocument.results.length > 0 : documentTools.findInDocument?.results > 0)) ? '135px' : '30px'}">
            <div
                *ngIf="documentTools.findInDocument.value && documentTools.findInDocument.results &&
            (externalParsingLibrary === 'OIT' && this.displayFormat !== DocumentFormat.TEXT ? documentTools.findInDocument.results.length : documentTools.findInDocument.results) > 0">
                <span>{{(documentTools.findInDocument.resultIndex
                    + 1) + ' / ' + (externalParsingLibrary === 'OIT' && this.displayFormat !== DocumentFormat.TEXT ?
                    documentTools.findInDocument.results.length :
                    documentTools.findInDocument.results)}}</span>
                <i class="fa fa-chevron-up" (click)="documentTools.findInDocument.previous()"
                    data-automation-id="document-viewer-document-filter-input-previous-button"></i>
                <i class="fa fa-chevron-down" (click)="documentTools.findInDocument.next()"
                    data-automation-id="document-viewer-document-filter-input-next-button"></i>
            </div>

            <i class="fa fa-times" *ngIf="documentTools.findInDocument.value && !documentTools.findInDocument.isBusy"
                (click)="documentTools.findInDocument.clear()"
                data-automation-id="document-viewer-document-filter-input-clear-button"></i>
            <i class="fa fa-search" [ngClass]="{'fa-search-disabled': !documentTools.findInDocument.enabled()}"
                *ngIf="!documentTools.findInDocument.value"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="documentTools.findInDocument.isBusy"
                data-automation-id="document-viewer-document-filter-input-busy-spinner"></i>
        </div>
        <button type="button" data-automation-id="document-viewer-first-document-button"
            class="secondary-button icon-button" (click)="moveToDocument.move('first')"
            [disabled]="moveToDocument.disabled.backward">
            <i class="fa fa-fast-backward color-blue-01"></i>
        </button>
        <button type="button" data-automation-id="document-viewer-previous-document-button" class="secondary-button"
            (click)="moveToDocument.move('previous')" [disabled]="moveToDocument.disabled.backward"
            [ngClass]="{'icon-button': width < 1260}">
            <i class="fa fa-backward color-blue-01"></i><span *ngIf="width >= 1260">Previous</span>
        </button>
        <button type="button" data-automation-id="document-viewer-next-document-button"
            class="secondary-button inverted-icon" (click)="moveToDocument.move('next')"
            [disabled]="moveToDocument.disabled.forward" [ngClass]="{'icon-button': width < 1260}">
            <span *ngIf="width >= 1260">Next</span><i class="fa fa-forward color-blue-01"></i>
        </button>
        <button type="button" data-automation-id="document-viewer-last-document-button"
            class="secondary-button icon-button" (click)="moveToDocument.move('last')"
            [disabled]="moveToDocument.disabled.forward">
            <i class="fa fa-fast-forward color-blue-01"></i>
        </button>
        <button type="button" data-automation-id="document-viewer-new-window-button"
            class="secondary-button icon-button borderless-button" *ngIf="!isExternalApp" (click)="spawnWindow()"
            title="Open the document viewer in a new window">
            <i class="fa fa-window-restore color-blue-01"></i>
        </button>
        <button type="button" class="help-button" data-automation-id="document-viewer-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <div class="content">
        <div id="leftDocViewerContent">
            <res-generic-grid #metadataGrid gridName="Metadata" automationId="document-viewer-metadata"
                [pagerVisible]="false" [isBusyOnInit]="true" [(isBusy)]="isBusy.metadata"
                [(isBusyMessage)]="isBusyMessage.metadata" [columnDefs]="columnDefs.metadata"
                [gridContext]="gridContext.metadata" [cellClickedCallback]="cellClickedCallback.metadata"
                [rowsHaveGrouping]="true" [rowsHaveTreeGrouping]="true"
                [onCustomFilterCallback]="onCustomFilterCallback">
            </res-generic-grid>
            <div class="metadata-toolbar">
                <res-custom-checkbox automationId="document-viewer-all-metadata-fields" [(ngModel)]="allMetadataFields"
                    (ngModelChange)="loadMetadata()" content="All Metadata Fields" [marginLeft]="10"
                    [disabled]="isBusy.metadata"></res-custom-checkbox>
                <res-custom-checkbox automationId="document-viewer-hide-empty-values" [(ngModel)]="hideEmptyMetadata"
                    (ngModelChange)="loadMetadata()" content="Hide Empty Values" [marginLeft]="20"
                    [disabled]="isBusy.metadata"></res-custom-checkbox>
                <button type="button" data-automation-id="document-viewer-download-metadata-button"
                    [disabled]="isBusy.metadata || !metadataXml" class="secondary-button icon-button"
                    (click)="downloadMetadata()" title="Download metadata (as shown) for this document (.xml)"
                    *ngIf="hasDownloadMetadataPermissions">
                    <i class="fa fa-download color-blue-01"></i>
                </button>
            </div>
        </div>
        <res-resizer #leftResizer anchor="left" resizingElementId="leftDocViewerContent"
            secondElementId="middleDocViewerContent" [collapsible]="true" [collapsed]="false" [initSize]="400"
            [marginToMaxParentSize]="10" collapsedIcon="fa-code" collapsedTitle="Show Metadata" [wideInputOnDrag]="true"
            data-automation-id="document-viewer-show-metadata-button"></res-resizer>
        <div id="middleDocViewerContent">
            <div id="topDocViewerContent" [resBusySpinner]="isBusy.document" [message]="isBusyMessage.document">
                <div class="document-toolbar" automationId="document-viewer-document-toolbar">
                    <div class="hidden-text-indicator" *ngIf="documentTools.hiddenContentTooltip"
                        [title]="documentTools.hiddenContentTooltip"
                        automationId="document-viewer-document-toolbar-hidden-text">
                        <i class="fa fa-low-vision"></i>
                    </div>
                    <div class="document-info" automationId="document-viewer-document-toolbar-document-info">
                        <i class="fa" *ngIf="selectedDocument && selectedDocument.iconClass"
                            [ngClass]="[selectedDocument.iconClass]"></i>
                        <span *ngIf="selectedDocument">{{documentTools.documentInfo.value ?
                            documentTools.documentInfo.value : selectedDocument.docnum}}</span>
                    </div>
                    <res-custom-checkbox class="highlight-search-terms"
                        *ngIf="documentTools.highlightSearchTerms.visible"
                        automationId="document-viewer-document-toolbar-highlight-search-terms"
                        [(ngModel)]="documentTools.highlightSearchTerms.value"
                        (ngModelChange)="documentTools.highlightSearchTerms.changed()" content="Highlight Search Terms"
                        [marginLeft]="10" [marginRight]="10" [disabled]="!documentTools.valid()"></res-custom-checkbox>
                    <div class="zoom-rotate-buttons" *ngIf="displayFormat !== 'TEXT'">
                        <button type="button" data-automation-id="document-viewer-document-toolbar-zoom-reset-button"
                            [disabled]="!documentTools.zoom.resetEnabled()"
                            class="secondary-button icon-button borderless-button" (click)="documentTools.zoom.reset()"
                            title="100%">
                            <span class="color-blue-01">100</span>
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-zoom-out-button"
                            [disabled]="!documentTools.zoom.outEnabled()"
                            class="secondary-button icon-button borderless-button" (click)="documentTools.zoom.out()"
                            title="Zoom Out">
                            <i class="fa fa-search-minus color-blue-01"></i>
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-zoom-in-button"
                            [disabled]="!documentTools.zoom.inEnabled()"
                            class="secondary-button icon-button borderless-button" (click)="documentTools.zoom.in()"
                            title="Zoom In">
                            <i class="fa fa-search-plus color-blue-01"></i>
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-zoom-width-button"
                            [disabled]="!documentTools.zoom.fitWidthEnabled()"
                            class="secondary-button icon-button borderless-button"
                            (click)="documentTools.zoom.fitWidth()" title="Fit Page Width">
                            <i class="fa fa-arrows-h color-blue-01"></i>
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-zoom-height-button"
                            [disabled]="!documentTools.zoom.fitHeightEnabled()"
                            class="secondary-button icon-button borderless-button"
                            (click)="documentTools.zoom.fitHeight()" title="Fit Page Height">
                            <i class="fa fa-arrows-v color-blue-01"></i>
                        </button>
                    </div>
                    <div class="zoom-rotate-buttons" *ngIf="displayFormat !== 'TEXT'">
                        <button type="button" data-automation-id="document-viewer-document-toolbar-rotate-left-button"
                            [disabled]="!documentTools.valid()" class="secondary-button icon-button borderless-button"
                            (click)="documentTools.rotate.left()" title="Rotate 90 degrees counter-clockwise">
                            <i class="fa fa-repeat fa-flip-horizontal color-blue-01"></i>
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-rotate-right-button"
                            [disabled]="!documentTools.valid()" class="secondary-button icon-button borderless-button"
                            (click)="documentTools.rotate.right()" title="Rotate 90 degrees clockwise">
                            <i class="fa fa-repeat color-blue-01"></i>
                        </button>
                    </div>
                    <li class="dropdown document-toolbar-dropdown save-text-as"
                        *ngIf="displayFormat !== 'IMAGE_PDF' && showAddSelectedTextTo" dropdown>
                        <div dropdownToggle role="button"
                            data-automation-id="document-viewer-document-toolbar-add-selected-text-to-dropdown"
                            [ngClass]="[documentTools.addSelectedText.selectedText ? '' : 'disabled']">
                            <i class="fa fa-plus color-green-04"></i>
                            <span>Add Selected Text to ...</span>
                            <i class="fa fa-caret-down color-blue-01"></i>
                        </div>
                        <ul *dropdownMenu class="dropdown-menu">
                            <li (click)="documentTools.addSelectedText.aliasList()"
                                data-automation-id="document-viewer-document-toolbar-add-selected-text-to-alias-list-select"
                                *ngIf="hasPrjAliaslistPermissions">
                                <i class="fa fa-address-book-o color-blue-01"></i><span>Alias List ...</span>
                            </li>
                            <li (click)="documentTools.addSelectedText.domainList()"
                                data-automation-id="document-viewer-document-toolbar-add-selected-text-to-domain-list-select"
                                *ngIf="hasPrjDomainListPermissions">
                                <i class="fa fa-at color-grey-10"></i><span>Domain List ...</span>
                            </li>
                            <li (click)="documentTools.addSelectedText.profile()"
                                data-automation-id="document-viewer-document-toolbar-add-selected-text-to-profile-select"
                                *ngIf="hasProfilesPermissions">
                                <i class="fa fa-align-left color-purple-02"></i><span>Synthetic Document ...</span>
                            </li>
                        </ul>
                    </li>
                    <li class="dropdown document-toolbar-dropdown download-document" dropdown
                        *ngIf="showDownloadButton && !currentBrowserIsIE">
                        <div dropdownToggle role="button"
                            data-automation-id="document-viewer-document-toolbar-download-dropdown"
                            [ngClass]="[documentTools.download.enabled() ? '' : 'disabled']">
                            <i class="fa fa-download color-blue-01"></i>
                            <i class="fa fa-caret-down color-blue-01"></i>
                        </div>
                        <ul *dropdownMenu class="dropdown-menu">
                            <li (click)="documentTools.download.native()"
                                data-automation-id="document-viewer-document-toolbar-download-native-select"
                                *ngIf="hasDownloadNativePermissions">
                                <i class="fa fa-file-o color-grey-10"></i><span>Native</span>
                            </li>
                            <li (click)="documentTools.download.pdf()"
                                [ngClass]="{'disabled' : !documentTools.download.pdfEnabled() }"
                                data-automation-id="document-viewer-document-toolbar-download-pdf-select"
                                *ngIf="hasDownloadPDFPermissions">
                                <i class="fa fa-file-pdf-o color-grey-10"></i><span>PDF</span>
                            </li>
                        </ul>
                    </li>
                    <div *ngIf="showDownloadButton && currentBrowserIsIE" class="download-document-inline">
                        <button type="button"
                            data-automation-id="document-viewer-document-toolbar-download-native-select"
                            class="secondary-button borderless-button" (click)="documentTools.download.native()"
                            *ngIf="hasDownloadNativePermissions">
                            <i class="fa fa-download color-blue-01"></i>Native
                        </button>
                        <button type="button" data-automation-id="document-viewer-document-toolbar-download-pdf-select"
                            class="secondary-button borderless-button" (click)="documentTools.download.pdf()"
                            *ngIf="hasDownloadPDFPermissions" [disabled]="!documentTools.download.pdfEnabled()">
                            <i class="fa fa-download color-blue-01"></i>PDF
                        </button>
                    </div>
                </div>
                <iframe #documentFrame class="document-content" [src]="documentUrl"
                    (load)="onDocumentLoaded()"></iframe>
            </div>
            <res-resizer #middleResizer anchor="bottom" resizingElementId="bottomDocViewerContent"
                secondElementId="topDocViewerContent" [collapsible]="true" [initSize]="300" [maxSize]="500"
                [wideInputOnDrag]="true"></res-resizer>
            <div id="bottomDocViewerContent" data-automation-id="document-viewer-doc-list-container">
                <res-generic-grid #historyGrid [hidden]="documentListTab !== 'history'" gridName="History"
                    automationId="document-viewer-history" [pagerVisible]="false" [isBusyOnInit]="true"
                    [(isBusy)]="isBusy.history" [(isBusyMessage)]="isBusyMessage.history"
                    [columnDefs]="columnDefs.history" [requestInfo]="requestInfo.history">
                </res-generic-grid>
                <res-document-list #familyGrid [hidden]="documentListTab !== 'family'"
                    [loadDataFinishedCallback]="loadDataFinishedCallback.familyList"
                    [onSelectionChanged]="onSelectionChanged.familyList"
                    [responseCallback]="responseCallback.familyList"></res-document-list>
                <res-document-list #threadGrid [hidden]="documentListTab !== 'thread'"
                    [loadDataFinishedCallback]="loadDataFinishedCallback.threadList"
                    [onSelectionChanged]="onSelectionChanged.threadList"
                    [responseCallback]="responseCallback.threadList"
                    [responseArrayCallback]="responseArrayCallback.threadList"></res-document-list>
                <res-document-list #docListGrid [hidden]="documentListTab !== 'docList'"
                    [loadDataFinishedCallback]="loadDataFinishedCallback.docList"
                    [onSelectionChanged]="onSelectionChanged.docList"></res-document-list>
            </div>
            <div class="bottom-toolbar">
                <res-custom-checkbox automationId="document-viewer-show-metadata" [ngModel]="showMetadata()"
                    (ngModelChange)="showMetadataChanged()" content="Show Metadata" [marginRight]="10">
                </res-custom-checkbox>
                <ul class="nav nav-tabs">
                    <li [ngClass]="{'active': documentListTab === 'history', 'disabled':!selectedDocument}"
                        data-automation-id="document-viewer-history-tab" (click)="setDocumentListTab('history')"
                        *ngIf="hasAuditAccessPermissions">
                        <a><i class="fa fa-history color-blue-01"></i>History</a>
                    </li>
                    <li [ngClass]="{'active': documentListTab === 'family', 'disabled':(!selectedDocument || !selectedDocument.hasFamily)}"
                        data-automation-id="document-viewer-family-tab"
                        (click)="setDocumentListTab(DocumentListTabType.family)">
                        <a><i class="fa fa-paperclip color-green-04"></i>Family</a>
                    </li>
                    <li [ngClass]="{'active': documentListTab === 'thread', 'disabled':(!selectedDocument || !selectedDocument.hasThread)}"
                        data-automation-id="document-viewer-thread-tab"
                        (click)="setDocumentListTab(DocumentListTabType.thread)">
                        <a><i class="fa fa-link color-blue-01"></i>Thread</a>
                    </li>
                    <li [ngClass]="{'active': documentListTab === 'docList' }"
                        data-automation-id="document-viewer-doc-list-tab"
                        (click)="setDocumentListTab(DocumentListTabType.docList)">
                        <a><i class="fa fa-list color-blue-01"></i>Doc List</a>
                    </li>
                </ul>
            </div>
        </div>
        <res-resizer anchor="right" resizingElementId="rightDocViewerContent" secondElementId="middleDocViewerContent"
            [collapsible]="false" [initSize]="400" [minSize]="360" [maxSize]="500" [ellipsisExpander]="true"
            [wideInputOnDrag]="true"></res-resizer>
        <div id="rightDocViewerContent" [resBusySpinner]="isBusy.tags" [message]="isBusyMessage.tags">
            <div class="tag-content">
                <div id="tagList" class="tag-list" data-automation-id="document-viewer-tags-container">
                    <div class="header">
                        <span>Tags</span>
                    </div>
                    <div class="tags-container">
                        <div *ngIf="hasTagsAddEditPermission" class="new-tag"
                            data-automation-id="document-viewer-tags-new-tag-button" (click)="newTag()">
                            <i class="fa fa-plus"></i>
                            <span>New Tag...</span>
                        </div>
                        <div class="tags-container-list">
                            <res-custom-checkbox *ngFor='let tag of tagList; index as i'
                                [automationId]="'document-viewer-tag-input-' + i" [(ngModel)]="tag.selected"
                                (ngModelChange)="tagSelected(tag)" [content]="tag.name" iconClass="fa-tag"
                                [iconHexColor]="tag.displayValue" [labelPaddingLeft]="10"
                                [disabled]="!hasDocumentTagPermissions"></res-custom-checkbox>
                        </div>
                    </div>
                </div>
                <res-resizer *ngIf="hasDocumentTagPermissions" anchor="up" resizingElementId="tagList"
                    secondElementId="tagQueue" [usePercentages]="true" [initSize]="50" [minSize]="20" [maxSize]="80"
                    [ellipsisExpander]="true"></res-resizer>
                <div id="tagQueue" class="tag-queue" *ngIf="hasDocumentTagPermissions"
                    data-automation-id="document-viewer-tags-queue-container">
                    <div class="header">
                        <span>Queue</span>
                        <button type="button" data-automation-id="document-viewer-tags-clear-queue-button"
                            class="secondary-button icon-button borderless-button" (click)="clearTagQueue()"
                            [disabled]="tagQueue.length == 0" title="Clear the Queue">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                    <res-generic-grid #tagQueueGrid automationId="document-viewer-tag-queue" [pagerVisible]="false"
                        [columnDefs]="columnDefs.tagQueue" [cellClickedCallback]="cellClickedCallback.tagQueue">
                    </res-generic-grid>
                </div>
            </div>
            <div class="tag-comment-apply" *ngIf="hasDocumentTagPermissions">
                <div class="header">
                    <span>Comment</span>
                </div>
                <div>
                    <textarea [(ngModel)]="tagComment" maxlength="255"></textarea>
                </div>
                <div>
                    <span>Apply All to:</span>
                    <button data-automation-id="document-viewer-tags-scope-document-tab-button" type="button"
                        [ngClass]="tagScope === TagScope.DOCUMENT_ONLY ? 'btn-group-active' : 'btn-group-default'"
                        (click)="tagScope = TagScope.DOCUMENT_ONLY" [disabled]="documentScopeDisabled">
                        <div>Document</div>
                        <i class="fa fa-caret-up up-caret-active"></i>
                    </button>
                    <button data-automation-id="document-viewer-tags-scope-family-tab-button" type="button"
                        [ngClass]="tagScope === TagScope.MESSAGE_ATTACHMENT_GROUP ? 'btn-group-active' : 'btn-group-default'"
                        (click)="tagScope = TagScope.MESSAGE_ATTACHMENT_GROUP" [disabled]="familyScopeDisabled">
                        <div>Family</div>
                        <i class="fa fa-caret-up up-caret-active"></i>
                    </button>
                    <button data-automation-id="document-viewer-tags-scope-thread-tab-button" type="button"
                        [ngClass]="tagScope === TagScope.EMAIL_THREAD ? 'btn-group-active' : 'btn-group-default'"
                        (click)="tagScope = TagScope.EMAIL_THREAD" [disabled]="threadScopeDisabled">
                        <div>Thread</div>
                        <i class="fa fa-caret-up up-caret-active"></i>
                    </button>
                </div>
                <div>
                    <button type="button" data-automation-id="document-viewer-tags-apply-button" class="primary-button"
                        title="Apply All Tagging Operations in the Queue" (click)="applyTagQueue()"
                        [disabled]="tagQueue.length == 0"><i class="fa fa-check"></i>Apply Queue</button>
                </div>
            </div>
        </div>
    </div>
    <a download #downloadLink hidden target="_blank"></a>
</div>